/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/


export default [
    {
        url: '/',
        name: "Dashboard",
        slug: "dashboard",
        icon: "HomeIcon",
        i18n: "Dashboard"
    },
    {
        url: null,
        name: "Master Data",
        slug: "MasterData",
        icon: "TruckIcon",
        i18n: "Vehicle",
        submenu: [
            {
                url: '/master-data/vehicle-provisioning',
                name: "Provisioning",
                slug: "Provisioning",
                i18n: "Provisioning",
            },
            {
                url: '/master-data/vehicle-replacement',
                name: "Replacement",
                slug: "Replacement",
                i18n: "Replacement",
            },
        ]
    },
    {
        url: null,
        name: "Fleet Group/Company",
        slug: "MasterData",
        icon: "ServerIcon",
        i18n: "Fleet Group Master",
        submenu: [
            {
                url: '/master-data/fleet-group',
                name: "Fleet Group",
                slug: "FleetGroup",
                i18n: "FleetGroup",
            },
        ]
    },
    {
        url: null,
        name: "User Management",
        slug: "UsersIcon",
        icon: "UsersIcon",
        i18n: "User Management",
        submenu: [
            {
                url: '/users/users-management',
                name: "User Account",
                slug: "User",
                i18n: "User",
            },
            {
                url: '/auth/menu-configuration',
                name: "Menu Configuration",
                slug: "ReportParam",
                i18n: "Menu Configuration",
            },
            {
                url: '/users/role-management',
                name: "Role & Permission",
                slug: "ReportParam",
                i18n: "Role & Permission",
            },
        ]
    },
    {
        url: null,
        name: "Geofence",
        slug: "MapIcon",
        icon: "MapIcon",
        i18n: "Geofence",
        submenu: [
            {
                url: '/master-data/geofence',
                name: "Configuration",
                slug: "geofence",
                i18n: "Configuration",
            },
            {
                url: '/master-data/mapping-geofence',
                name: "Vehicle Mapping",
                slug: "ReportParam",
                i18n: "Vehicle Mapping",
            },
        ]
    },
    {
        url: null,
        name: "Alert",
        slug: "BellIcon",
        icon: "BellIcon",
        i18n: "Alert",
        submenu: [
            {
                url: '/master-data/alert',
                name: "Alert Configuration",
                slug: "alertConfig",
                i18n: "Alert Configuration",
            },
            {
                url: '/master-data/mapping-alert',
                name: "Alert Mapping",
                slug: "AlertMapping",
                i18n: "Alert Mapping",
            },
            {
                url: '/alert-history',
                name: "Alert History",
                slug: "AlertHistory",
                i18n: "Alert History",
            },
        ]
    },
    {
        url: null,
        name: "POI",
        slug: "MapPinIcon",
        icon: "MapPinIcon",
        i18n: "Point of Interest",
        submenu: [
            {
                url: '/master-data/category-poi',
                name: "POI Category",
                slug: "poiCategory",
                i18n: "POI Category",
            },
            {
                url: '/master-data/poi',
                name: "POI List",
                slug: "POIList",
                i18n: "POI List",
            },
        ]
    },
]
